

        <app-avis-initial-type  [uid]="getUid()" [parentForm]="parentForm" [avisInitial]="rectificatif.avisInitial"></app-avis-initial-type>



